//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: 'CarList',
  mixins: [JeecgListMixin],
  components: {},
  data: function data() {
    return {
      pagePath: '/ea/asset/car',
      pageTitle: '车辆档案',
      carList: {},
      photo: '',
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
        queryCarPhoto: '/ea/asset/car/queryCarPhoto'
      }
    };
  },
  created: function created() {
    this.loadCarList();
  },
  computed: {},
  methods: {
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    //  加载车辆照片
    loadCarList: function loadCarList() {
      var _this = this;

      var that = this;
      that.carList = {}; // 车牌号

      getAction(this.url.queryCarPhoto).then(function (res) {
        if (res.success) {
          var result = res.result;
          var list = []; // that.carList = res.result

          for (var i = 0; i < result.length; i++) {
            var carRepair = result[i];
            carRepair.key = carRepair.id;
            carRepair.photo = _this.getImageView(carRepair.photo);
            list.push(carRepair);
          }

          that.carList = list;
        }
      });
    },
    carChange: function carChange(carId) {
      this.$router.push({
        path: '/assets/car/CarDetailedList',
        query: {
          carId: carId
        }
      });
    }
  }
};